<template>
  <div>
    <h1>Undertakings</h1>
    <v-select
      v-model="teamid"
      :items="teams"
      item-value="id"
      label="Team"
      @change="navigate"
      outline
    >
      <template slot="selection" slot-scope="data"
        >{{ data.item.code }} - {{ data.item.name }}</template
      >
      <template slot="item" slot-scope="data"
        >{{ data.item.code }} - {{ data.item.name }}</template
      >
      <template slot="append-outer" v-if="teamid">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <a
              @click="
                teamid = null;
                navigate();
              "
              v-on="on"
            >
              <v-icon>clear</v-icon>
            </a>
          </template>
          <span>Show all teams</span>
        </v-tooltip>
      </template>
    </v-select>
    <v-btn @click="emailUndertakings" v-if="$keycloak.hasRealmRole('root')">
      <v-icon>send</v-icon>Send undertaking email
    </v-btn>
    <v-data-table
      :headers="headers"
      :items="modifiedUndertakings"
      hide-actions
      class="elevation-1"
      :pagination.sync="pagination"
      :loading="loading"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <FileZ :file="props.item.file" v-if="props.item.file" />
            <span v-if="!props.item.file">{{ props.item.fileid }}</span>
          </td>
          <td>
            <span v-if="props.item.undertakingType">{{
              props.item.undertakingType.body
            }}</span>
            <span v-if="!props.item.undertakingType">{{
              props.item.typeid
            }}</span>
          </td>
          <td>{{ props.item.timestamp | formatDate }}</td>
          <td>{{ props.item.nagdate | formatDate }}</td>
          <td>{{ props.item.age }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="sendingEmail" persistent width="300">
      <v-card color="info" dark>
        <v-card-text>
          <span>Waiting for server to send Undertaking email...</span>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TEAMS from "@/graphql/directory/Teams";
import FileZ from "@/components/link/FileZ";
import { convertListOfObjectsToMap } from "@/util/helpers";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "UndertakingReport",
  metaInfo() {
    return {
      title: "Undertakings",
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { FileZ },
  apollo: {
    teams: {
      query: TEAMS,
      variables: { archived: false },
      fetchPolicy: "cache-and-network"
    }
  },
  computed: {
    modifiedUndertakings() {
      if (!this.undertakings) {
        return undefined;
      }
      const undertakingTypeMap = this.undertakingTypes
        ? convertListOfObjectsToMap(this.undertakingTypes, "id")
        : undefined;
      const now = new Date();
      return this.undertakings.map((u) => {
        const file = this.files ? this.files[u.fileid] : undefined;
        const undertakingType =
          undertakingTypeMap && undertakingTypeMap[u.typeid]
            ? undertakingTypeMap[u.typeid]
            : undefined;
        const timestamp = new Date(u.timestamp);
        const diff = now.getTime() - timestamp.getTime();
        const age = Math.round(diff / (1000 * 3600 * 24));
        return {
          ...u,
          undertakingType,
          file,
          age
        };
      });
    }
  },
  data() {
    return {
      undertakings: [],
      files: [],
      teamid: null,
      headers: [
        {
          text: "Reference",
          value: "referencelong"
        },
        {
          text: "Undertaking",
          value: "undertakingType.body"
        },
        {
          text: "Timestamp",
          value: "timestamp"
        },
        {
          text: "Nag date",
          value: "nagdate"
        },
        {
          text: "Age (days)",
          value: "age"
        }
      ],
      pagination: {
        sortBy: "timestamp",
        descending: false,
        page: 1,
        rowsPerPage: -1
      },
      loading: false,
      sendingEmail: false
    };
  },
  methods: {
    fetchUndertakings() {
      this.loading = true;
      nbmlaw
        .get(`/cors/admin/directory/teams/${this.teamid}/undertakings`)
        .then((response) => {
          // console.log(response.data);
          this.undertakings = response.data;
          this.loading = false;
        })
        .catch(() => {});
    },
    fetchFiles() {
      nbmlaw
        .get(`/cors/admin/directory/teams/${this.teamid}/undertakings/files`)
        .then((response) => {
          // console.log(response.data);
          this.files = response.data;
        })
        .catch(() => {});
    },
    fetchUndertakingTypes() {
      nbmlaw.get(`/cors/admin/file/undertakingTypes`).then((response) => {
        // console.log(response.data);
        this.undertakingTypes = response.data;
      });
    },
    navigate() {
      this.$router.push({
        name: "undertakings",
        query: { teamid: this.teamid }
      });
    },
    emailUndertakings() {
      this.sendingEmail = true;
      nbmlaw.put(`/cors/admin/file/undertakings`, null).then(() => {
        // console.log(response.data);
        this.sendingEmail = false;
      });
    }
  },
  watch: {
    "$route.query.teamid": {
      immediate: true,
      handler() {
        this.teamid = this.$route.query.teamid;
        this.files = [];
        if (this.teamid) {
          this.fetchUndertakings();
          this.fetchFiles();
        }
      }
    }
  },
  created() {
    this.fetchUndertakingTypes();
  }
};
</script>

<style>
</style>
